import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Shell } from "@/components/Shell";
import { joinTeam } from "@/lib/api";

export default function Join() {
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const team = await joinTeam({ game_code: code.toUpperCase(), name: name.trim() });
      localStorage.setItem(`team_${team.id}`, JSON.stringify(team));
      nav(`/team/${team.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not join");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Shell>
      <div className="max-w-lg">
        <div className="font-mono-data text-[10px] tracking-[0.3em] text-[color:var(--dxc-volt)] uppercase">
          Team Join
        </div>
        <h1 className="font-serif-display text-5xl mt-2">Enter game.</h1>

        <form onSubmit={submit} className="dxc-card p-8 mt-8">
          <input
            data-testid="join-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase().slice(0, 6))}
            placeholder="GAME CODE"
            className="dxc-input font-mono-data text-3xl tracking-[0.4em]"
            autoFocus
          />
          <input
            data-testid="join-name-input"
            value={name}
            onChange={(e) => setName(e.target.value.slice(0, 40))}
            placeholder="Team name"
            className="dxc-input mt-4"
          />
          <button
            disabled={loading}
            data-testid="join-submit"
            className="dxc-btn dxc-btn-volt w-full mt-6 text-sm"
          >
            {loading ? "Joining…" : "Join →"}
          </button>
        </form>

        <Link to="/" className="mt-4 inline-block text-xs text-white/50 hover:text-white font-mono-data tracking-widest">
          ← Back
        </Link>
      </div>
    </Shell>
  );
}
